import React, { useEffect } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from "axios";
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import * as accessControlObj from '../authentication/accessControlMap'

const FacilityMedSheetForm = (props) => {
    const [reportFormat, setReportFormat] = useState(localStorage.getItem('medsheetFormat') || '0');
    const [medsheet, setMedSheet] = useState("");
    const [checked, setChecked] = React.useState(true);
    const [spinner, showSpinner] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [unverifiedCount, setUnverifiedCount] = useState(0);
    const [reportDateError, setReportDateError] = useState(false);
    const [reportFormatError, setReportFormatError] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [formData, setFormData] = useState({
        reportdate: '',
        reportformat: '',
        is_drug_hcp: 'drug',
        //is_medgroup: true,
        // is_highalert: true,
        is_prn: true,
        is_regular: true
    });

    const [reportdate, setReportDate] = useState(null);
    const [showResults, setShowResults] = React.useState(false)

    const navigate = useNavigate();
    let localStorageAccessControl = localStorage.getItem("accessControl");

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    useEffect(() => {
        if (spinner) {
            setShowResults(false);
        }
    }, [spinner])

    const generateTreatmentReport = async () => {
        if ((localStorage.getItem("patientId") != null || localStorage.getItem("reportFacilityId") != null) && reportFormat != "" && reportdate != null) {

            showSpinner(true);

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsMedSheetUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/medsheet-exp";

            //console.log("is_drug_hcp " + localStorage.getItem("patientId"));

            let pelmedsMedSheetData = localStorage.getItem("reportFacilityId") == null ?
                {
                    date: reportdate != null ? moment(reportdate).format('MMM YYYY') : null,//"01-10-2024",            
                    patient_id: localStorage.getItem("patientId"),
                    medsheet_format: reportFormat,
                    is_hcp: formData.is_drug_hcp == "hcp" ? 1 : 0,
                    is_drug: formData.is_drug_hcp == "drug" ? 1 : 0,
                    // is_medgroup: formData.is_medgroup ? 1 : 0,
                    // is_highalert: formData.is_highalert ? 1 : 0,
                    is_prn: formData.is_prn ? 1 : 0,
                    is_regular: formData.is_regular ? 1 : 0
                } :
                {
                    date: reportdate != null ? moment(reportdate).format('MMM YYYY') : null,//"01-10-2024",            
                    facility_id: localStorage.getItem("reportFacilityId"),
                    medsheet_format: reportFormat,
                    is_hcp: formData.is_drug_hcp == "hcp" ? 1 : 0,
                    is_drug: formData.is_drug_hcp == "drug" ? 1 : 0,
                    //   is_medgroup: formData.is_medgroup ? 1 : 0,
                    //   is_highalert: formData.is_highalert ? 1 : 0,
                    is_prn: formData.is_prn ? 1 : 0,
                    is_regular: formData.is_regular ? 1 : 0
                };

            //console.log("pelmedsMedSheetData " + JSON.stringify(pelmedsMedSheetData));

            const data = await axios.post(pelmedsMedSheetUrl, pelmedsMedSheetData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

            // if (data.status) {
            //     setMedSheet(data.medsheet_url);
            //     setShowResults(true);
            //     // if(props?.formname){
            //     // }
            //     //console.log(JSON.stringify(medsheet));

            //     // if (localStorage.getItem("reportFacilityId") == null) {
            //     //     props.onCallParent(); //only required for reports at patient level not at facility level
            //     // } else {
            //     //     toast.success("MedSheet Generated Successfully");
            //     //     localStorage.removeItem("reportFacilityId");
            //     // }
            // }
            // else {
            //     // toast.error("Error while generating the medsheet report");
            //     toast.error(data.message);
            // }
            // showSpinner(false);

            if (data?.data?.status == false) {
                toast.error(data.data.message);
            }
            else {
                toast.success("MedSheet Generated Successfully");
                const blob = new Blob([data.data], { type: "text/html" });
                const blobUrl = URL.createObjectURL(blob);
                setIframeSrc(blobUrl);
            }
            showSpinner(false);
        }
    }

    // Handler
    const handleSubmit = async e => {
        e.preventDefault();
        if (props?.validateFacility) {
            if (!props?.validateFacility()) return;
        }
        const dateValid = reportdate !== null;
        const formatValid = reportFormat != '0';

        setReportDateError(!dateValid);
        setReportFormatError(!formatValid);

        if (!dateValid || !formatValid) {
            return;
        }
        const unverified = props?.data?.prescriptions?.filter(p => (p.is_verified == 0 && p.discontinued_date == null)) || [];

        if (unverified.length > 0 && localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
            setUnverifiedCount(unverified.length);
            setShowConfirmModal(true);
            return;
        }
        generateTreatmentReport();
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;

        if (name === "reportformat") {
            setReportFormat(value);
        }
        setShowResults(false);
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    const handleRadioChange = e => {
        setShowResults(false);
        setChecked((state) => !state)
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    return (
        <div>
            <Form onSubmit={handleSubmit}>
                {showConfirmModal && (
                    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Unverified Orders</h5>
                                </div>
                                <div className="modal-body">
                                    <p>There are {unverifiedCount} unverified orders, do you want to continue?</p>
                                </div>
                                <div className="modal-footer d-flex justify-content-between">
                                    <Button variant="secondary" onClick={() => handleUnverifiedView()}>
                                        Unverified Orders
                                    </Button>
                                    <div>
                                        <Button variant="primary" className="me-2" onClick={() => {
                                            setShowConfirmModal(false);
                                            generateTreatmentReport();
                                        }}>
                                            Yes
                                        </Button>
                                        <Button variant="secondary" onClick={() => {
                                            setShowConfirmModal(false);
                                        }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label className="required">Report Date</Form.Label>
                            <DatePicker name="reportdate" selected={reportdate} autoComplete="off" onChange={(selectedDate) => {
                                setShowResults(false);
                                setReportDate(selectedDate);
                            }}
                                dateFormat="MMM yyyy" showMonthYearPicker className='form-control form-control-sm' placeholderText="Select Report Date" />
                            {reportDateError && <div className="invalid-feedback">Report date is required</div>}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label className="required">Report Format</Form.Label>
                            <Form.Select name="reportformat"
                                onChange={handleFieldChange}
                                value={reportFormat}
                                disabled={localStorage.getItem("medsheetFormat") !== "0"}
                                size="sm">
                                <option value='0'>Select your Format</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                                <option value='7'>7</option>
                                <option value='8'>8</option>
                                <option value='9'>9</option>
                                <option value='10'>10</option>
                                <option value='11'>11</option>
                            </Form.Select>
                            {reportFormatError && <div className="invalid-feedback">Report format is required</div>}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Sort By</Form.Label>
                            <Row>
                                <Col>
                                    <Form.Check
                                        type='radio'
                                        name="is_drug_hcp"
                                        id='is_drug'
                                        value="drug"
                                        onChange={handleRadioChange}
                                        label='Drug'
                                        defaultChecked={checked}
                                    />
                                </Col>
                                <Col>
                                    <Form.Check
                                        type='radio'
                                        name="is_drug_hcp"
                                        id='is_hcp'
                                        value="hcp"
                                        onChange={handleRadioChange}
                                        label='HCP'
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>MedSheet For</Form.Label>
                            <Row>
                                <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_regular"
                                        id='is_regular'
                                        checked={
                                            formData.is_regular
                                        }
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                is_regular: e.target.checked
                                            })
                                        }
                                        label='Regular'
                                    />
                                </Col>
                                <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_prn"
                                        id='is_prn'
                                        checked={
                                            formData.is_prn
                                        }
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                is_prn: e.target.checked
                                            })
                                        }
                                        label='PRN'
                                    />
                                </Col>
                                {/* <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_highalert"
                                        id='is_highalert'
                                        checked={
                                            formData.is_highalert
                                        }
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                is_highalert: e.target.checked
                                            })
                                        }
                                        label='High Alert'
                                    />
                                </Col>
                                <Col>
                                    <Form.Check
                                        type='switch'
                                        name="is_medgroup"
                                        id='is_medgroup'
                                        checked={
                                            formData.is_medgroup
                                        }
                                        onChange={e =>
                                            setFormData({
                                                ...formData,
                                                is_medgroup: e.target.checked
                                            })
                                        }
                                        label='MedGroup'
                                    />
                                </Col> */}
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col></Col>
                    <Col>
                        <Form.Group>
                            {spinner && (
                                <Button variant="primary" disabled className="mt-3 w-100">
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="p-2" style={{ "verticalAlign": "3px" }}>Fetching...</span>
                                </Button>
                            )}
                            {!spinner && (
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="mt-3 w-100">
                                    Generate
                                </Button>
                            )}
                            <div style={{
                                height: 0,
                                overflow: 'hidden',
                                width: 0
                            }}>
                                {iframeSrc && (
                                    <iframe
                                        src={iframeSrc}
                                        style={{ width: "2000px", height: "500px", border: "none" }}
                                        title="Preview Content"
                                    />
                                )}
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                    </Col>
                </Row>
            </Form>
            <br />
            {/* {showResults && (
                <a href={medsheet} target="_blank" rel="noreferrer">
                    <button className="btn btn-primary">
                        📄 Download Report
                    </button>
                </a>
            )} */}
        </div>
    );
};

FacilityMedSheetForm.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

FacilityMedSheetForm.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default FacilityMedSheetForm;
